
import { useCallback } from 'react';
import { PERMISSIONS_CONFIG } from '../config/permissionsConfig';

/**
 * Hook for managing debounced permission refresh
 */
export const useDebouncedRefresh = (
  refreshPermissions: () => Promise<void>,
  debounceTimeoutRef: React.MutableRefObject<NodeJS.Timeout | null>
) => {
  const debouncedRefreshPermissions = useCallback(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      refreshPermissions();
    }, PERMISSIONS_CONFIG.DEBOUNCE_DELAY);
  }, [refreshPermissions, debounceTimeoutRef]);

  return { debouncedRefreshPermissions };
};
